module.exports = __webpack_public_path__ + "static/media/ocosAllocation.31520aec.png";